import { render } from "./NotificationHeader.vue?vue&type=template&id=230bf426&scoped=true"
import script from "./NotificationHeader.vue?vue&type=script&lang=js"
export * from "./NotificationHeader.vue?vue&type=script&lang=js"

import "./NotificationHeader.vue?vue&type=style&index=0&id=230bf426&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230bf426"]])

export default __exports__